import { render, staticRenderFns } from "./OvertimeTable.vue?vue&type=template&id=2b8dc18b&scoped=true&"
import script from "./OvertimeTable.vue?vue&type=script&lang=js&"
export * from "./OvertimeTable.vue?vue&type=script&lang=js&"
import style0 from "./OvertimeTable.vue?vue&type=style&index=0&id=2b8dc18b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8dc18b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VChip,VIcon,VSimpleCheckbox,VSimpleTable})
